import { Globe, Landmark, Radio } from "lucide-react";

export function SourceBadge({ source }) {
  if (!source) return null;
  if (source === "fmp") {
    return (
      <span data-testid="source-badge" className="inline-flex items-center gap-1 rounded bg-emerald-500/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-emerald-300" title="Financial Modeling Prep">
        <Globe className="h-2.5 w-2.5" /> FMP
      </span>
    );
  }
  if (source === "cftc") {
    return (
      <span data-testid="source-badge" className="inline-flex items-center gap-1 rounded bg-purple-500/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-purple-300" title="CFTC Commitments of Traders">
        <Landmark className="h-2.5 w-2.5" /> CFTC
      </span>
    );
  }
  // Sources publiques agrégées (FRED, Finnhub, RSS, Frankfurter, Yahoo…)
  return (
    <span data-testid="source-badge" className="inline-flex items-center gap-1 rounded bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-400" title="Données de marché en direct">
      <Radio className="h-2.5 w-2.5" /> Live
    </span>
  );
}
